import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ChatMessage from './ChatMessage';
import { getExperienceType } from '../../data/experienceTypes';

export default function ChatView({ conversation, onClose }) {
  const navigate = useNavigate();

  const handleContinueChat = () => {
    // Navigate to dashboard and open chat with this conversation
    window.dispatchEvent(new CustomEvent('openChat', { detail: { conversationId: conversation.id } }));
    navigate('/');
  };

  return (
    <div className="bg-white rounded-card shadow-card h-full flex flex-col min-h-[500px]">
      {/* Header */}
      <div className="flex items-center justify-between p-4 sm:p-5 border-b border-border">
        <div className="flex-1">
          <h2 className="font-semibold text-text-primary text-lg sm:text-xl mb-1">
            {conversation.title || 'Conversation'}
          </h2>
          {conversation.projectId && (
            <span className="text-xs px-2 py-0.5 bg-primary/20 text-primary rounded-full">
              {getExperienceType(conversation.projectType)?.name || 'Experience'}
            </span>
          )}
        </div>
        <button
          onClick={onClose}
          className="text-text-secondary hover:text-text-primary transition-colors lg:hidden"
        >
          <FontAwesomeIcon icon={faPlus} className="rotate-45" />
        </button>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 sm:p-5">
        {conversation.messages && conversation.messages.length > 0 ? (
          conversation.messages.map((message, index) => (
            <ChatMessage 
              key={index} 
              message={message} 
              isUser={message.role === 'user'} 
            />
          ))
        ) : (
          <div className="text-center text-text-secondary py-8">
            <p>No messages in this conversation</p>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="p-4 sm:p-5 border-t border-border">
        <button
          onClick={handleContinueChat}
          className="w-full px-4 py-2.5 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark transition-all"
        >
          Continue This Conversation
        </button>
      </div>
    </div>
  );
}

